import React from 'react';
import './LoadingDots.css';

type Props = {
  text: string;
  color?: string;
};

const TextLoading: React.FC<Props> = ({ text, color }) => {
  return (
    <span className="loading" style={{ color }}>
      {text}
    </span>
  );
};

export { TextLoading };
